import { useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Container } from "../components/Container";
import { SectionTitle } from "../components/SectionTitle";
import { useComputeAdminLicenseStatsMutation } from "../query/adminLicenseStatsQuery";
import { useComputeAdminMrrStatsMutation } from "../query/adminMrrStatsQuery";
import { useSalesPeriodState } from "../hooks/useSalesPeriodState";
import { ActiveLicensesChart } from "./components/ActiveLicensesChart";
import { DashboardValueBoxes } from "./components/DashboardValueBoxes";
import { LicenseTypesPieChart } from "./components/LicenseTypesPieChart";
import { SalesStatsSection } from "./components/SalesStatsSection";
import { MrrStatsSection } from "./components/MrrStatsSection";
import { ResellerTopListSection } from "./components/ResellerTopListSection";
import { spacing } from "@styling/sizing";

const ChartsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.x2}px;

  @media (min-width: 900px) {
    grid-template-columns: 1fr 320px;
  }
`;

export const AdminDashboardView = () => {
  const { t } = useTranslation();
  const periodState = useSalesPeriodState();
  const { mutate: computeAdminLicenseStats } = useComputeAdminLicenseStatsMutation();
  const { mutate: computeAdminMrrStats } = useComputeAdminMrrStatsMutation();

  useEffect(() => {
    computeAdminLicenseStats();
    computeAdminMrrStats();
  }, [computeAdminLicenseStats, computeAdminMrrStats]);

  return (
    <Container>
      <SalesStatsSection
        periodState={periodState}
      />
      <MrrStatsSection periodState={periodState} />
      <SectionTitle>{t("adminLicenseStats.sectionTitle")}</SectionTitle>
      <DashboardValueBoxes
        date={periodState.selectedDate}
        selectedDateLabel={periodState.selectedDateLabel}
      />
      <ChartsRow>
        <ActiveLicensesChart
          from={periodState.period.from}
          to={periodState.period.to}
          selectedDate={periodState.selectedDate}
          onSelectDate={periodState.handleSelectDate}
        />
        <LicenseTypesPieChart
          date={periodState.selectedDate}
          selectedDateLabel={periodState.selectedDateLabel}
        />
      </ChartsRow>
      <ResellerTopListSection />
    </Container>
  );
};
